import { scenarios } from '@/mocks/home';
import SectionHeading from './SectionHeading';
import ScrollReveal from './ScrollReveal';

export default function Scenarios() {
  return (
    <section className="bg-gray-50/50">
      <div className="section-padding">
        <SectionHeading
          index="02"
          eyebrow="阅读场景"
          title="随时随地，想读就读"
          subtitle="无论你身处何地，天天漫画下载都能陪伴左右，填满每一个碎片时刻。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-6xl mx-auto">
          {scenarios.map((scenario, i) => (
            <ScrollReveal key={scenario.title} delay={i * 80}>
              <div className="group relative h-full flex flex-col items-center text-center rounded-lg border-2 border-gray-900 bg-white px-6 py-9 shadow-[4px_4px_0_0_#ff9db8] hover:shadow-[4px_4px_0_0_#1a1a1a] hover:-translate-y-1.5 transition-all duration-300 overflow-hidden">
                <div className="absolute top-2 right-2 w-8 h-8 halftone-pink pointer-events-none" />
                <div className="relative mb-6">
                  <div className="w-16 h-16 rounded-lg border-2 border-gray-900 bg-pink-50 flex items-center justify-center group-hover:bg-pink-500 group-hover:border-gray-900 transition-all duration-300">
                    <i
                      className={`${scenario.icon} text-2xl text-pink-500 group-hover:text-white transition-colors duration-300`}
                    />
                  </div>
                  <span className="absolute -right-2 -top-2 w-6 h-6 rounded-md border-2 border-gray-900 bg-white flex items-center justify-center">
                    <span className="w-2 h-2 rounded-sm bg-pink-500" />
                  </span>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{scenario.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{scenario.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}